export const SETTINGS = 'SETTINGS_BJ';
